var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    isAddPatchModalOpen: false,
    isLBAddPatchModalOpen: false,
    isSearchModalOpen: false,
    isLBSearchModalOpen: false,
    isFilterModalOpen: false,
    isDeleteConfirmationOpen: false,
    isLBDeleteConfirmationOpen: false,
    isShortcutModalOpen: false,
    isLBShortcutModalOpen: false,
    isAutoAlignConfirmationModalOpen: false,
    isCreateCustomLogicModalOpen: false,
    isContextMenuOpen: false,
    modalPosition: null,
    linkEvent: undefined,
    addModalTabIndex: 0,
    helpModalOpen: false,
    selectionMode: false,
    selectedPatchCount: 0,
};
export var uiSlice = createSlice({
    name: 'ui',
    initialState: initialState,
    reducers: {
        changeAddPatchModalState: function (state, action) {
            state.isAddPatchModalOpen = action.payload;
        },
        changeLBAddPatchModalState: function (state, action) {
            state.isLBAddPatchModalOpen = action.payload;
        },
        changeSearchPatchState: function (state, action) {
            state.isSearchModalOpen = action.payload;
        },
        changeLBSearchPatchState: function (state, action) {
            state.isLBSearchModalOpen = action.payload;
        },
        changeFilterPopUpState: function (state, action) {
            state.isFilterModalOpen = action.payload;
        },
        setDeleteConfirmationState: function (state, action) {
            state.isDeleteConfirmationOpen = action.payload;
        },
        setLBDeleteConfirmationState: function (state, action) {
            state.isLBDeleteConfirmationOpen = action.payload;
        },
        changeShortcutPopupState: function (state, action) {
            state.isShortcutModalOpen = action.payload;
        },
        changeLBShortcutPopupState: function (state, action) {
            state.isLBShortcutModalOpen = action.payload;
        },
        changeAutoAlignConfirmationModalState: function (state, action) {
            state.isAutoAlignConfirmationModalOpen = action.payload;
        },
        changeCreateCustomLogicModalState: function (state, action) {
            state.isCreateCustomLogicModalOpen = action.payload;
        },
        changeContextMenuState: function (state, action) {
            state.isContextMenuOpen = action.payload;
        },
        updateModalPosition: function (state, action) {
            state.modalPosition = action.payload;
        },
        fireEvent: function (state, action) {
            state.linkEvent = action.payload;
        },
        setTabIndex: function (state, action) {
            state.addModalTabIndex = action.payload;
        },
        setHelpModalStatus: function (state, action) {
            state.helpModalOpen = action.payload;
        },
        setSelectionMode: function (state, action) {
            state.selectionMode = action.payload;
        },
        setSelectedPatchCount: function (state, action) {
            state.selectedPatchCount = action.payload;
        },
    },
});
export var changeAddPatchModalState = (_a = uiSlice.actions, _a.changeAddPatchModalState), changeLBAddPatchModalState = _a.changeLBAddPatchModalState, changeSearchPatchState = _a.changeSearchPatchState, changeLBSearchPatchState = _a.changeLBSearchPatchState, changeShortcutPopupState = _a.changeShortcutPopupState, changeLBShortcutPopupState = _a.changeLBShortcutPopupState, changeAutoAlignConfirmationModalState = _a.changeAutoAlignConfirmationModalState, changeCreateCustomLogicModalState = _a.changeCreateCustomLogicModalState, changeContextMenuState = _a.changeContextMenuState, updateModalPosition = _a.updateModalPosition, fireEvent = _a.fireEvent, setTabIndex = _a.setTabIndex, setSelectionMode = _a.setSelectionMode, changeFilterPopUpState = _a.changeFilterPopUpState, setDeleteConfirmationState = _a.setDeleteConfirmationState, setLBDeleteConfirmationState = _a.setLBDeleteConfirmationState, setHelpModalStatus = _a.setHelpModalStatus, setSelectedPatchCount = _a.setSelectedPatchCount;
export default uiSlice.reducer;
